import { Link } from "react-router-dom";

export function NotFound() {
  return (
    <section className="grid min-h-[70vh] place-items-center bg-sand py-20">
      <div className="container text-center">
        <p className="eyebrow">404</p>
        <h1 className="text-5xl font-bold text-charcoal">الصفحة غير موجودة</h1>
        <p className="mt-4 text-lg text-ash">الرابط المطلوب غير متاح.</p>
        <Link className="btn btn-primary mt-8" to="/">
          العودة للرئيسية
        </Link>
      </div>
    </section>
  );
}
